/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ExceptionReviewUpdate = {
    readonly uuid?: string;
    exception: string;
    review_date?: string;
    /**
     * Reviewer of the exception.
     */
    reviewer: string;
    status?: ExceptionReviewUpdate.status;
    notes?: string | null;
}

export namespace ExceptionReviewUpdate {

    export enum status {
        UNKNOWN = 'unknown',
        APPROVED = 'approved',
        DENIED = 'denied',
        TENTATIVE = 'tentative',
    }


}
